/**
 * Title of an app page, for the dashboard "frequently used" tiles
 * (QuickActions) and the page-visit tracker: `pages.<path>` in the locale
 * files, else the nearest parent path that has one
 * ("/modules/hr/employees/new" without its own title -> "Employees"), else
 * null. Every static route of App.js has a `pages.<path>` key
 * (pageTitle.test.js guards that), so the visit's stored title (the language
 * of the visit) is only a last resort.
 */
export function pageTitle(t, path) {
  let p = typeof path === 'string' ? path.replace(/\/+$/, '') : '';
  while (p) {
    const key = `pages.${p}`;
    const value = t(key);
    if (typeof value === 'string' && value && value !== key) return value;
    p = p.slice(0, p.lastIndexOf('/'));
  }
  return null;
}

export default pageTitle;
